module.exports = __webpack_public_path__ + "static/media/ePharmacie_process_flow_Slide2_English.57a6bb91.png";